module.exports = __webpack_public_path__ + "static/media/illo_map.75e44dec.png";